import { Route } from 'react-router-dom';
import ProtectedRoute from '../components/global/ProtectedRoute';
import OptionGroups from '../pages/optionGroups/OptionGroups';
import CreateOptionGroup from '../pages/optionGroups/CreateOptionGroup';
import EditOptionGroup from '../pages/optionGroups/EditOptionGroup';

const optionGroupsRoutes = (
    <>
        {/* Option Groups Routes */}
        <Route path="option-groups" element={
            <ProtectedRoute requiredPermission="products.manage">
                <OptionGroups />
            </ProtectedRoute>
        } />

        <Route path="option-groups/create" element={
            <ProtectedRoute requiredPermission="products.manage">
                <CreateOptionGroup />
            </ProtectedRoute>
        } />

        <Route path="option-groups/:id/edit" element={
            <ProtectedRoute requiredPermission="products.manage">
                <EditOptionGroup />
            </ProtectedRoute>
        } />
    </>
);

export default optionGroupsRoutes;
